/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { reserveSettingsSchema } from "./reserveSettingsSchema.ts";

export const orgUnitReserveSettingsRetrievePathOrgUnitIdSchema = z.uuid();

export const orgUnitReserveSettingsRetrieveStatus200Schema = reserveSettingsSchema.describe("Настройки бронирования точки: нужны фронту для формы брони.");

export const orgUnitReserveSettingsRetrieveResponseSchema = orgUnitReserveSettingsRetrieveStatus200Schema;
